import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy brand-hub leaf → brand workbench drawer (full mode,
// visuals tab). See the brand workbench design doc (CommitMind).
export const Route = createFileRoute('/brand/$slug/_brand/visuals')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/brand/$slug/home',
      params: { slug: params.slug },
      search: { brand: 'full', brandTab: 'visuals' },
    });
  },
});
